export default __webpack_public_path__ + "static/media/background1.be88b384.png";